<template>
    <v-container style="padding-top: 80px">
        <v-row mb-2>
            <v-chip class="ma-2 chipSize" :color="this.colorReporte" style="align-self: center" large
                @click="detalleReporte()">
                <span class="txtRep"> Reporte: {{ this.RepInd }} </span>
            </v-chip>

            <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                <span class="txtEtiq">
                    {{ this.etiqueta }}
                </span>
            </v-chip>
        </v-row>
        <v-card class="mt-2 pb-0 mb-5">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;"> Criterio del Lider </p>
            </v-card-title>

            <v-card-text style="margin-bottom: 4%;">
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <div class="mt-3">
                            <v-form ref="form" v-model="validForm" lazy-validation>
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; font-weight: bold;">
                                    Responsabilidad por parte de
                                </h4>
                                <p>De conformidad al criterio del líder, el responsable es:</p>
                                <v-row>
                                    <v-col md="12">
                                        <v-radio-group v-model="sacriteriolider" :error-messages="errorResponsabilidad">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Asegurado" value="NA"></v-radio>
                                                    <v-radio label="Corresponsabilidad" value="CO"></v-radio>
                                                    <v-radio label="Tercero" value="TR"></v-radio>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Golpe Fuga" value="GF"></v-radio>
                                                    <v-radio label="No se puede determinar" value="ND"></v-radio>
                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </v-col>

                                </v-row>
                                <br />
                                <v-textarea v-model="sadesclider" :counter="$store.state.maxLengthComentarios" outlined
                                    rows="2" v-on:blur="sadesclider = sadesclider != null ? sadesclider.trim() : null"
                                    :rules="rulestextareaDet" :disabled="textareadisabled"
                                    :filled="textareadisabled"></v-textarea>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disBtn"
                        @click="Guardar()">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" title="Limpiar" @click="limpiar()" :disabled="disBtn">
                        Limpiar
                    </v-btn>
                    <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

import { mapState } from "vuex";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            sacriteriolider: null,
            textareadisabled: true,
            errorResponsabilidad: '',
            sadesclider: '',
            disBtn: false,
            rulestextareaDet: [
                v => {
                    if (v == null || v == '') {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            validForm: true,
            permisoLideres: false,
            reporte: {
                nrreporte: 0,
                svindice: 0
            },
            colorReporte: '',
            RepInd: '',
            colorClass: "",
            etiqueta: '',
            asistenciaurl: '',
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        etiqueta(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
        'sacriteriolider'(val) {
            if (val != null) {
                this.errorResponsabilidad = "";
            }
            if (val == 'ND') {
                this.textareadisabled = false;
                this.rulestextareaDet = [];
                setTimeout(() => {
                    this.rulestextareaDet = [
                        v => {
                            if (v == null || v == '') {
                                return 'Campo requerido'
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > this.$store.state.maxLengthComentarios) {
                                    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
            else {
                this.textareadisabled = true;
                this.sadesclider = ''
                this.rulestextareaDet = [];
                setTimeout(() => {
                    this.rulestextareaDet = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > this.$store.state.maxLengthComentarios) {
                                    return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);
            }
        },
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        let reporte = await MetodosGenerales.obtenerSessionReporte('valider');
        this.reporte.nrreporte = reporte.nrreporte;
        this.reporte.svindice = reporte.svindice;
        this.reporte.aiclave = reporte.aiclave;
        this.reporte.svfhconclusion = reporte.svfhconclusion;

        let datos = await Lideres.DatosCriterioLider(reporte);
        this.sacriteriolider = datos.sacriteriolider != '' ? datos.sacriteriolider : null;
        this.sadesclider = datos.sadesclider != '' ? datos.sadesclider : '';

        let encabezado = await Lideres.EncabezadoReporte(this.reporte);
        this.RepInd = encabezado.nrreportei;
        this.colorReporte = encabezado.color;
        this.etiqueta = encabezado.etiqueta;
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);

    },
    methods: {
        async detalleReporte() {
            let reporte = {
                nrreporte: this.reporte.nrreporte,
                svindice: this.reporte.svindice,
                aiclave: this.reporte.aiclave,
                svfhconclusion: this.reporte.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", this.reporte.nrreporte);
            formData.append("svindice", this.reporte.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });
            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(this.reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });
            }
        },
        limpiar() {
            this.errorResponsabilidad = '';
            this.sacriteriolider = null;
            this.sadesclider = '';
        },
        Cancelar() {
            this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
        },
        async Guardar() {
            this.$refs.form.validate();
            this.errorResponsabilidad = this.sacriteriolider == null ? 'Seleccione al menos una respuesta.' : '';
            if (this.errorResponsabilidad == '' && this.$refs.form.validate()) {
                this.disBtn = true;
                this.$swal({
                    title: 'Procesando solicitud',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await Lideres.GuardarCriterioLider(this.reporte.nrreporte, this.reporte.svindice, this.sacriteriolider, this.sadesclider);
                        if (response == true) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Correcto",
                                text: "Criterio del líder guardado correctamente.",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                timer: 2500,
                            }).then(() => {
                                this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
                            });
                        } else {
                            this.$swal({
                                position: "center",
                                icon: "warning",
                                title: "Error",
                                text: "Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                timer: 2500,
                            });
                            this.disBtn = false;
                        }
                    }
                });
            }
        }
    }
}
</script>

<style></style>